import React, { ReactNode } from 'react';
import { NotificationTypeEnum } from './NotificationTypeEnum';

export interface ContextNotification {
  message: string;
  type: NotificationTypeEnum;
  autoHideDuration?: number | false;
  key: string;
  action?: ReactNode;
  open: boolean;
  height?: number;
}

export type PushNotificationFn = (
  notification: ContextNotificationWithoutKey,
) => string;

export type RemoveNotificationFn = (key: string) => void;

export type ContextNotificationWithoutKey = Pick<
  ContextNotification,
  Exclude<keyof ContextNotification, 'key' | 'open'>
>;

export interface NotificationContextType {
  notificationStack: ContextNotification[];
  pushNotification: PushNotificationFn;
  removeNotification: RemoveNotificationFn;
  exitedNotification: RemoveNotificationFn;
  setHeight: (elem: HTMLDivElement, key: string) => void;
}

export interface ContextState {
  notificationStack: ContextNotification[];
}

export const NotificationContext = React.createContext<
  NotificationContextType | undefined
>(undefined);
